(function () {
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  /* ---------- YouTube click-to-play ---------- */
  document.addEventListener('click', function (e) {
    var box = e.target.closest('[data-ihf-yt]');
    if (!box || box.dataset.loaded) return;
    box.dataset.loaded = '1';
    var f = document.createElement('iframe');
    f.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(box.dataset.ihfYt) + '?autoplay=1&rel=0&modestbranding=1';
    f.title = 'YouTube video';
    f.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
    f.allowFullscreen = true;
    box.innerHTML = '';
    box.appendChild(f);
  });

  /* ---------- Quick buy drop-up: variation -> size -> cart ---------- */
  function isSize(name) { return /size|length|inch|ring/i.test(name) ? 1 : 0; }

  function initQB(card) {
    if (card.dataset.qbReady) return;
    card.dataset.qbReady = '1';
    var data = JSON.parse(card.querySelector('[data-qb-json]').textContent);
    var steps = card.querySelector('[data-qb-steps]');
    var add = card.querySelector('[data-qb-add]');
    var priceEl = card.querySelector('[data-qb-price]');
    var msg = card.querySelector('[data-qb-msg]');
    var opts = data.options;
    var single = data.variants.length === 1 && data.variants[0].options[0] === 'Default Title';
    var order = opts.map(function (n, i) { return i; }).sort(function (a, b) { return isSize(opts[a]) - isSize(opts[b]) || a - b; });
    var sel = [];

    function fits(v, upto) {
      for (var k = 0; k < upto; k++) { var p = order[k]; if (sel[p] != null && v.options[p] !== sel[p]) return false; }
      return true;
    }
    function current() {
      if (single) return data.variants[0];
      return data.variants.find(function (v) { return v.options.every(function (o, i) { return sel[i] === o; }); });
    }
    function update() {
      var v = current();
      if (v) {
        priceEl.textContent = v.price;
        add.disabled = !v.available;
        add.textContent = v.available ? 'Add to cart' : 'Sold out';
        add.dataset.id = v.id;
      } else {
        var first = data.variants[0];
        priceEl.textContent = first ? first.price : '';
        add.disabled = true;
        add.textContent = 'Add to cart';
        delete add.dataset.id;
      }
    }
    function render() {
      steps.innerHTML = '';
      if (!single) {
        for (var k = 0; k < order.length; k++) {
          var oi = order[k];
          var ready = order.slice(0, k).every(function (p) { return sel[p] != null; });
          if (!ready) break;
          var wrap = document.createElement('div');
          wrap.className = 'ihf-qb__step';
          var lab = document.createElement('p');
          lab.className = 'ihf-qb__label';
          lab.textContent = (k + 1) + '. Choose ' + opts[oi].toLowerCase() + (sel[oi] != null ? ': ' + sel[oi] : '');
          wrap.appendChild(lab);
          var row = document.createElement('div');
          row.className = 'ihf-qb__vals';
          var seen = {};
          data.variants.forEach(function (v) {
            var val = v.options[oi];
            if (seen[val]) return;
            seen[val] = 1;
            var avail = data.variants.some(function (w) { return w.options[oi] === val && w.available && fits(w, k); });
            var b = document.createElement('button');
            b.type = 'button';
            b.className = 'ihf-qb__val' + (sel[oi] === val ? ' is-on' : '');
            b.textContent = String(val).replace(/-/g, ' ');
            b.disabled = !avail;
            b.addEventListener('click', (function (idx, kk, value) {
              return function () {
                sel[idx] = value;
                for (var j = kk + 1; j < order.length; j++) sel[order[j]] = null;
                msg.hidden = true;
                render();
              };
            })(oi, k, val));
            row.appendChild(b);
          });
          wrap.appendChild(row);
          steps.appendChild(wrap);
        }
      }
      update();
    }
    render();

    add.addEventListener('click', function () {
      if (!add.dataset.id) return;
      add.disabled = true;
      add.textContent = 'Adding…';
      fetch(ROOT + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(add.dataset.id), quantity: 1 }] })
      }).then(function (r) {
        return r.json().then(function (j) {
          if (!r.ok) throw new Error(j.description || j.message || 'Could not add to cart');
          add.textContent = 'Added to cart';
          setTimeout(function () { window.location.href = ROOT + 'cart'; }, 450);
        });
      }).catch(function (err) {
        msg.textContent = err.message;
        msg.hidden = false;
        update();
      });
    });
  }

  function closeAll(except) {
    document.querySelectorAll('[data-qb-panel]').forEach(function (p) {
      if (p === except) return;
      p.hidden = true;
      var t = p.closest('[data-qb]').querySelector('[data-qb-toggle]');
      if (t) t.setAttribute('aria-expanded', 'false');
    });
  }

  /* A click counts as inside the panel even if the button it hit was just re-rendered away. */
  function inPanel(e) {
    var path = e.composedPath ? e.composedPath() : [];
    for (var i = 0; i < path.length; i++) {
      if (path[i].hasAttribute && path[i].hasAttribute('data-qb-panel')) return true;
    }
    return !!(e.target.closest && e.target.closest('[data-qb-panel]'));
  }

  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-qb-toggle]');
    if (toggle) {
      var card = toggle.closest('[data-qb]');
      var panel = card.querySelector('[data-qb-panel]');
      var open = panel.hidden;
      closeAll(panel);
      panel.hidden = !open;
      toggle.setAttribute('aria-expanded', String(open));
      if (open) initQB(card);
      return;
    }
    if (e.target.closest('[data-qb-close]')) { closeAll(null); return; }
    if (!inPanel(e)) closeAll(null);
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(null); });

  /* ---------- Scroll reveal + parallax ---------- */
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce || !('IntersectionObserver' in window)) return;
  document.documentElement.classList.add('ihf-js');

  var SEL = '.ihf-split > *, .ihf-tile, .ihf-card, .ihf-post, .ihf-tabs, .ihf-center, .ihf-footer__reviews, .ihf-footer__cols > div, .ihf-wordmark, .ihf-hero__top, .ihf-hero__bottom, .ihf-hero__promo, .ihf-article__head > *, .ihf-article__hero, .ihf-video, .ihf-prose > *, .ihf-ad, .ihf-article__cta';
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

  function scan(root) {
    (root || document).querySelectorAll(SEL).forEach(function (el) {
      if (el.dataset.ihfR) return;
      el.dataset.ihfR = '1';
      var i = el.parentElement ? Array.prototype.indexOf.call(el.parentElement.children, el) : 0;
      el.style.setProperty('--ihf-d', Math.min(i, 6) * 70 + 'ms');
      el.classList.add('ihf-reveal');
      io.observe(el);
    });
  }
  scan();
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });

  var imgs = document.querySelectorAll('.ihf-hero__img, .ihf-article__hero img');
  if (imgs.length) {
    var ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        var y = Math.min(window.scrollY, 900);
        imgs.forEach(function (img) { img.style.transform = 'translate3d(0,' + (y * 0.12).toFixed(1) + 'px,0) scale(1.08)'; });
        ticking = false;
      });
    }, { passive: true });
  }
})();